<template lang="pug">
.sidebar-block
  .sidebar-heading
    a(@click="settings.open = !settings.open")
      span {{ heading }}
      b-icon(:icon="settings.open ? 'angle-down' : 'angle-up'" pack="fas" size="is-small")
  .sidebar-content(v-if="settings.open && filters.length > 0")
    b-field(
      v-for="filter in filters"
      :key="filter.id"
    )
      .level.is-mobile(:class="{ 'is-active': isFiltered(filter) }")
        .level-left
          b-checkbox(
            :value="selected"
            :native-value="filter.id"
            @input="set($event, filter, index)"
          )
            span {{ filter.label }}
        .level-right
          b-tag {{ filter.count }}
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

export default {
  name: 'service-sidebar-block',
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      episodesFilters: getterTypes.GET_SERVICES_FILTERS,
    }),
    selected() {
      return _.map(this.episodesFilters[this.index], 'id');
    },
  },
  data() {
    return {
      settings: {
        open: true,
      },
    };
  },
  methods: {
    isFiltered(filter) {
      return this.selected.length === 0 || _.indexOf(this.selected, filter.id) >= 0;
    },
    set(checked, val, key) {
      this.$store.commit(mutationTypes.TOGGLE_SERVICES_FILTER, {
        key,
        val,
      });
      this.$store.commit(mutationTypes.SET_SERVICES_REFRESH, true);
    },
  },
  props: {
    heading: {
      type: String,
      default: null,
    },
    index: {
      type: String,
      default: null,
    },
    filters: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>


<style theme="ffc" lang="scss" scoped>
.sidebar-block {
  .sidebar-heading {
    border-top: 1px solid #eaeaea;
    font-size: 1.05rem;
    a {
      color: $grey-darker;
    }
  }
  .sidebar-content {
    padding-top: 0.75rem;
    .level:not(.is-active) {
      span.tag {
        background-color: $white-ter;
        color: $grey-darker;
      }
    }
  }
}
</style>

<style theme="cwo" lang="scss" scoped>
.sidebar-block {
  & + .sidebar-block {
    border-top: 1px solid #eaeaea;
  }
  .sidebar-heading {
    font-family: $heading-font;
    font-size: 1.15rem;
    a {
      color: $grey-darker;
      text-transform: uppercase;
      .icon {
        color: #d8d8d8;
      }
    }
  }
  .sidebar-content {
    padding-top: 0.5rem;
    .field {
      margin-bottom: 0.75rem;
    }
    .b-checkbox {
      .check {

      }
    }
    .level {
      span.tag {
        background-color: $grey-lighter;
        color: $grey;
        font-family: $heading-font;
      }
      &.is-active {
        span.tag {
          color: $white;
          background-color: $primary;
        }
      }
    }

  }
}
</style>
